import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'

import Header from '../components/Header'
import Footer from '../components/Footer'
import '../stylesheets/main.scss'

import appleTouchIcon from './apple-touch-icon.png'
import favicon32 from './favicon-32x32.png'
import favicon16 from './favicon-16x16.png'
import safariTab from './safari-pinned-tab.svg'
import manifest from './manifest.json'

const TemplateWrapper = ({ children }) => (
  <div>
    <Helmet>
      <meta charSet="utf-8" />
      <meta http-equiv="X-UA-Compatible" content="IE=edge,chrome=1" />
      <base href="/" />

      <title>Natalie Johnson</title>
      <meta name="description" content="Natalie Johnson is a Sydney-based designer and developer." />

      <meta name="viewport" content="width=device-width,initial-scale=1" />

      <link rel="apple-touch-icon" sizes="180x180" href={appleTouchIcon} />
      <link rel="icon" type="image/png" href={favicon32} sizes="32x32" />
      <link rel="icon" type="image/png" href={favicon16} sizes="16x16" />
      <link rel="mask-icon" href={safariTab} color="#323236" />
      <meta name="apple-mobile-web-app-title" content="Natalie Johnson" />
      <meta name="application-name" content="Natalie Johnson" />
      <meta name="theme-color" content="#ffffff" />

      <meta name="pinterest" content="nopin" />
      <meta name="p:domain_verify" content="de916c186e12527fb748718d723d052c"/>
    </Helmet>
    <Header/>
    <div>
      {children()}
    </div>
    <Footer />
  </div>
)

TemplateWrapper.propTypes = {
  children: PropTypes.func,
}

export default TemplateWrapper



// WEBPACK FOOTER //
// ./src/layouts/index.js